var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFileText = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.9998 4H11.9998C10.9389 4 9.92147 4.42143 9.17133 5.17157C8.42118 5.92172 7.99976 6.93913 7.99976 8V40C7.99976 41.0609 8.42118 42.0783 9.17133 42.8284C9.92147 43.5786 10.9389 44 11.9998 44H35.9998C37.0606 44 38.078 43.5786 38.8282 42.8284C39.5783 42.0783 39.9998 41.0609 39.9998 40V16L27.9998 4Z",
  stroke: "#172B4D",
  strokeWidth: 3.94928,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9998 4V16H39.9998",
  stroke: "#172B4D",
  strokeWidth: 3.94928,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9998 26H15.9998",
  stroke: "#172B4D",
  strokeWidth: 3.94928,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9998 34H15.9998",
  stroke: "#172B4D",
  strokeWidth: 3.94928,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9998 18H17.9998H15.9998",
  stroke: "#172B4D",
  strokeWidth: 3.94928,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file-text.61863906.svg";
export { ForwardRef as ReactComponent };